import { StrictMode } from 'react'

// ── 배포 직후 죽은 청크 자동 복구 ─────────────────────────────────────────────
// dist 는 라이브 바인드마운트라 빌드 = 즉시 배포다. 배포 시점에 열려 있던 탭은
// 옛 index.html 이 가리키는 청크 해시를 요청하다 404 로 죽는다
// ("Failed to fetch dynamically imported module" — /myshelf 에서 실제로 났다).
// 그 오류를 잡아 **한 번만** 새로고침한다 — 새 index.html 을 받으면 해결된다.
// 무한 새로고침을 막기 위해 세션당 1회로 제한하고, 성공적으로 뜨면 표식을 지운다.
const RELOAD_KEY = 'chunk-reload-at'
function recoverFromDeadChunk(reason: unknown) {
  const msg = String((reason as Error)?.message ?? reason ?? '')
  if (!/Failed to fetch dynamically imported module|Importing a module script failed/.test(msg)) return
  const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0)
  if (Date.now() - last < 30_000) return // 방금 새로고침했는데 또 실패 → 루프 방지
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
  window.location.reload()
}
window.addEventListener('unhandledrejection', e => recoverFromDeadChunk(e.reason))
window.addEventListener('error', e => recoverFromDeadChunk(e.error ?? e.message))

import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import '@fontsource/inter/400.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/poppins/400.css'
import '@fontsource/poppins/600.css'
import '@fontsource/poppins/700.css'
import './index.css'
import { SettingsProvider } from './components/providers/SettingsProvider'
import { applyTextScale, readTextScale } from './lib/textScale'

applyTextScale(readTextScale())

function isLightPublicPath(pathname: string) {
  return pathname === '/'
    || pathname === '/home'
    || pathname === '/news'
    || pathname === '/book'
    || pathname.startsWith('/book/')
}

async function bootstrap() {
  const pathname = window.location.pathname
  const module = isLightPublicPath(pathname)
    ? await import('./PublicApp.tsx')
    : await import('./App.tsx')

  const ActiveApp = module.default

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <BrowserRouter>
        <SettingsProvider>
          <ActiveApp />
        </SettingsProvider>
      </BrowserRouter>
    </StrictMode>,
  )
}

bootstrap()
